<template>
  <form @submit.prevent="createStory">
    <div class="card">
      <div class="card-header">Project Set Up</div>
      <div class="card-body">
        <div class="row pad-top-20">
          <div class="col-4">
            <label class="typo__label">Displaying Device</label>
            <multiselect
              v-model="experiences.deviceSelected"
              :options="experiences.devices"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              @select="deviceChanged"
              placeholder="Pick a device"
            ></multiselect>
          </div>
          <div class="col-4">
            <label class="typo__label">Device Maker</label>
            <multiselect
              v-model="experiences.deviceMakerSelected"
              :disabled="!experiences.deviceSelected"
              :options="experiences.deviceMaker"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              placeholder="Pick a maker"
            ></multiselect>
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-4">
            <label class="typo__label">Experience</label>
            <multiselect
              v-model="experiences.experienceSelected"
              :options="
                experiences.deviceSelected === 'Mobile'
                  ? experiences.mobileExperienceOptions
                  : experiences.deviceSelected === 'Hands Free'
                  ? experiences.handsfreeExperienceOptions
                  : experiences.hmdExperienceOptions
              "
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              :disabled="!experiences.deviceMakerSelected"
              placeholder="Pick a experience"
            ></multiselect>
          </div>
          <div class="col-4">
            <label class="typo__label">Surf Options</label>
            <multiselect
              v-model="experiences.surfOptionsSelected"
              :options="experiences.surfOptions"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              :disabled="!experiences.experienceSelected"
              placeholder="Pick a Surf"
            ></multiselect>
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-4">
            <label class="typo__label">Camera Options(Only On 'AR')</label>
            <multiselect
              v-show="experiences.experienceSelected === 'AR'"
              v-model="experiences.arSelectedOption"
              :options="experiences.arOptions"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :disabled="!experiences.surfOptionsSelected"
              placeholder="Pick a camera"
            ></multiselect>
          </div>
          <div class="col-4">
            <label class="typo__label">Final Product</label>
            <multiselect
              v-model="experiences.finalProductSelected"
              :options="experiences.finalProduct"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              :multiple="false"
              :disabled="
                !experiences.arSelectedOption &&
                !experiences.surfOptionsSelected
              "
              placeholder="Pick a product"
            ></multiselect>
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8">
            <label class="typo__label">Choose Industry</label>
            <multiselect
              v-model="experiences.chooseIndustrySelected"
              :options="experiences.chooseIndustry"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              :multiple="true"
              placeholder="Industries"
            ></multiselect>
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8 flexSpaceBetween text-right">
            <router-link
              :to="{ name: 'add-story-step-1' }"
              class="btn btn-primary text-field-style"
            >
              Previous
            </router-link>
            <button
              type="submit"
              class="btn btn-primary text-field-style"
              :disabled="
                !(
                  experiences.finalProductSelected &&
                  experiences.experienceSelected &&
                  experiences.finalProductSelected &&
                  experiences.surfOptionsSelected &&
                  experiences.deviceSelected &&
                  experiences.deviceMakerSelected
                )"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { db } from "../../../firebaseDB";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

let storyRef = db.ref("stories");
export default {
  name: "step2",
  firebase: {
    stories: storyRef,
  },
  components: {
    Multiselect,
  },
  data: () => ({
    dialog: false,
    user: null,
    experiences: {
      devices: ["Mobile", "HMD", "Hands Free"],
      deviceSelected: "Mobile",
      mobileExperienceOptions: ["Screens", "VR", "AR"],
      hmdExperienceOptions: ["VR", "AR"],
      handsfreeExperienceOptions: ["VR"],
      experienceSelected: "AR",
      arOptions: ["Front Camera", "Back Camera"],
      arSelectedOption: "Back Camera",
      deviceMaker: ["iOS/Android", "Windows", "Linux"],
      deviceMakerSelected: "iOS/Android",
      surfOptions: ["App", "Browser"],
      surfOptionsSelected: "App",
      finalProduct: ["Sub-channel inside ABXR App", "Other"],
      finalProductSelected: "Sub-channel inside ABXR App",
      chooseIndustry: [
        "Ed Tech",
        "Health",
        "Entertainment",
        "movies",
        "Spirituality",
        "Gaming",
      ],
      chooseIndustrySelected: [],
    },

    newStory: {
    },
  }),
  beforeCreate() {
    if (this.$store.state.newStory.id = null) {
      this.$router.push("/newprofile/add-story/step-1");
    }
  },
  methods: {
    createStory() {
      console.log(this.$store.state.newStory);
      let storyKey;
      this.newStory.experience = {};
      this.newStory.experience.device = this.experiences.deviceSelected;
      this.newStory.experience.type = this.experiences.experienceSelected;
      this.newStory.experience.default =
        this.experiences.arSelectedOption !== ""
          ? this.experiences.arSelectedOption
          : null;
      this.newStory.experience.deviceMakerSelected =
        this.experiences.deviceMakerSelected;
      this.newStory.experience.surfOptionsSelected =
        this.experiences.surfOptionsSelected;
      this.newStory.experience.finalProductSelected =
        this.experiences.finalProductSelected;
      this.newStory.experience.chooseIndustrySelected =
        this.experiences.chooseIndustrySelected;
      this.newStory.date = new Date(Date.now())
        .toISOString()
        .slice(0, 10);
      this.$store.state.newStory.experience = this.newStory.experience;
      this.$store.state.newStory.date = this.newStory.date;
  //    this.$store.state.newStory.json = this.newStory.json;
      const storiesRef = db.ref().child("stories");   
      storyKey = storiesRef.push( this.$store.state.newStory).key;
      this.$store.state.newStory.id = storyKey;
      this.$store.dispatch("setNewAddedStoryId",  this.$store.state.newStory.id);
      localStorage.setItem("storyId",  this.$store.state.newStory.id);
      this.$router.push({ name: "mainStoryView" });
    },
    deviceChanged: function () {
      if (this.experiences.experienceSelected === "Screens") {
        this.experiences.experienceSelected = "";
        this.experiences.arSelectedOption = "";
        this.experiences.surfOptionsSelected = "";
      }
    },
  },
};
</script>
<style>
.text-field-style {
  border-radius: 6px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/add_story/step2.vue